import { render } from "./Contact.vue?vue&type=template&id=c52c4776&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=c52c4776&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c52c4776"

export default script